var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trade_middle_top_item_box",class:_vm.$route.query.Moudles == 'Trade'
      ? ' trade_middle_top_item_bg'
      : _vm.$route.meta.title == 'companyDetails'
      ? ' search_middle_top_item_bg'
      : '',attrs:{"id":"defaultId1"}},[_c('div',{staticClass:"u3da49",attrs:{"id":"ge25b1"}},[_c('div',{staticClass:"text_label"},[_vm._v(" "+_vm._s(_vm.total)+" ")])]),(_vm.$route.query.Moudles == 'Trade')?_c('div',{class:_vm.$route.query.Moudles == 'Trade'
        ? 'trade_middle_top_item_text'
        : 'u8dd69',attrs:{"id":"g87d25"}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):(_vm.$route.meta.title == 'companyDetails')?_c('div',{class:_vm.$route.meta.title == 'companyDetails'
        ? 'trade_middle_top_item_text'
        : 'u8dd69',attrs:{"id":"g87d25"}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_c('el-tooltip',{attrs:{"disabled":_vm.total.length < 50,"content":_vm._f("FilterNum")(_vm.total),"placement":"top"}},[_c('div',{class:_vm.$route.query.Moudles == 'Trade'
          ? 'trade_middle_top_item_text'
          : 'u8dd69',attrs:{"id":"g87d25"}},[_vm._v(" "+_vm._s(_vm.label)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }